/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssistitoUpdateDTO
 */
export interface AssistitoUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof AssistitoUpdateDTO
     */
    nome?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoUpdateDTO
     */
    cognome?: string;
    /**
     * 
     * @type {Date}
     * @memberof AssistitoUpdateDTO
     */
    dataDiNascita?: Date;
    /**
     * 
     * @type {string}
     * @memberof AssistitoUpdateDTO
     */
    codiceFiscale?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoUpdateDTO
     */
    sesso?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoUpdateDTO
     */
    nascitaNazioneId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoUpdateDTO
     */
    nascitaRegioneId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoUpdateDTO
     */
    nascitaProvinciaId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoUpdateDTO
     */
    nascitaComuneId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoUpdateDTO
     */
    nascitaRegione?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoUpdateDTO
     */
    nascitaProvincia?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoUpdateDTO
     */
    nascitaComune?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoUpdateDTO
     */
    residenzaRegione?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoUpdateDTO
     */
    residenzaProvincia?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoUpdateDTO
     */
    residenzaComune?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoUpdateDTO
     */
    residenzaNazioneId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoUpdateDTO
     */
    residenzaRegioneId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoUpdateDTO
     */
    residenzaProvinciaId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoUpdateDTO
     */
    residenzaComuneId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoUpdateDTO
     */
    residenzaIndirizzo?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoUpdateDTO
     */
    residenzaCAP?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoUpdateDTO
     */
    residenzaNumeroCivico?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoUpdateDTO
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoUpdateDTO
     */
    telefono?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoUpdateDTO
     */
    cellulare?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoUpdateDTO
     */
    note?: string;
}

/**
 * Check if a given object implements the AssistitoUpdateDTO interface.
 */
export function instanceOfAssistitoUpdateDTO(value: object): value is AssistitoUpdateDTO {
    return true;
}

export function AssistitoUpdateDTOFromJSON(json: any): AssistitoUpdateDTO {
    return AssistitoUpdateDTOFromJSONTyped(json, false);
}

export function AssistitoUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistitoUpdateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'nome': json['nome'] == null ? undefined : json['nome'],
        'cognome': json['cognome'] == null ? undefined : json['cognome'],
        'dataDiNascita': json['dataDiNascita'] == null ? undefined : (new Date(json['dataDiNascita'])),
        'codiceFiscale': json['codiceFiscale'] == null ? undefined : json['codiceFiscale'],
        'sesso': json['sesso'] == null ? undefined : json['sesso'],
        'nascitaNazioneId': json['nascita_NazioneId'] == null ? undefined : json['nascita_NazioneId'],
        'nascitaRegioneId': json['nascita_RegioneId'] == null ? undefined : json['nascita_RegioneId'],
        'nascitaProvinciaId': json['nascita_ProvinciaId'] == null ? undefined : json['nascita_ProvinciaId'],
        'nascitaComuneId': json['nascita_ComuneId'] == null ? undefined : json['nascita_ComuneId'],
        'nascitaRegione': json['nascita_Regione'] == null ? undefined : json['nascita_Regione'],
        'nascitaProvincia': json['nascita_Provincia'] == null ? undefined : json['nascita_Provincia'],
        'nascitaComune': json['nascita_Comune'] == null ? undefined : json['nascita_Comune'],
        'residenzaRegione': json['residenza_Regione'] == null ? undefined : json['residenza_Regione'],
        'residenzaProvincia': json['residenza_Provincia'] == null ? undefined : json['residenza_Provincia'],
        'residenzaComune': json['residenza_Comune'] == null ? undefined : json['residenza_Comune'],
        'residenzaNazioneId': json['residenza_NazioneId'] == null ? undefined : json['residenza_NazioneId'],
        'residenzaRegioneId': json['residenza_RegioneId'] == null ? undefined : json['residenza_RegioneId'],
        'residenzaProvinciaId': json['residenza_ProvinciaId'] == null ? undefined : json['residenza_ProvinciaId'],
        'residenzaComuneId': json['residenza_ComuneId'] == null ? undefined : json['residenza_ComuneId'],
        'residenzaIndirizzo': json['residenza_Indirizzo'] == null ? undefined : json['residenza_Indirizzo'],
        'residenzaCAP': json['residenza_CAP'] == null ? undefined : json['residenza_CAP'],
        'residenzaNumeroCivico': json['residenza_NumeroCivico'] == null ? undefined : json['residenza_NumeroCivico'],
        'email': json['email'] == null ? undefined : json['email'],
        'telefono': json['telefono'] == null ? undefined : json['telefono'],
        'cellulare': json['cellulare'] == null ? undefined : json['cellulare'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function AssistitoUpdateDTOToJSON(value?: AssistitoUpdateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'nome': value['nome'],
        'cognome': value['cognome'],
        'dataDiNascita': value['dataDiNascita'] == null ? undefined : ((value['dataDiNascita'] as any).toISOString()),
        'codiceFiscale': value['codiceFiscale'],
        'sesso': value['sesso'],
        'nascita_NazioneId': value['nascitaNazioneId'],
        'nascita_RegioneId': value['nascitaRegioneId'],
        'nascita_ProvinciaId': value['nascitaProvinciaId'],
        'nascita_ComuneId': value['nascitaComuneId'],
        'nascita_Regione': value['nascitaRegione'],
        'nascita_Provincia': value['nascitaProvincia'],
        'nascita_Comune': value['nascitaComune'],
        'residenza_Regione': value['residenzaRegione'],
        'residenza_Provincia': value['residenzaProvincia'],
        'residenza_Comune': value['residenzaComune'],
        'residenza_NazioneId': value['residenzaNazioneId'],
        'residenza_RegioneId': value['residenzaRegioneId'],
        'residenza_ProvinciaId': value['residenzaProvinciaId'],
        'residenza_ComuneId': value['residenzaComuneId'],
        'residenza_Indirizzo': value['residenzaIndirizzo'],
        'residenza_CAP': value['residenzaCAP'],
        'residenza_NumeroCivico': value['residenzaNumeroCivico'],
        'email': value['email'],
        'telefono': value['telefono'],
        'cellulare': value['cellulare'],
        'note': value['note'],
    };
}

